import { TradeAck } from 'epic/common-form/Trade';
import { NextWorkflowError } from 'models/NextWorkflowError';
import { HandledWorkspace as Workspaces } from 'state/forms/models';
import { QuoteType } from 'state/quotes/infos/infos.model';
export type CommonStreamingAction = ReturnType<(typeof commonStreamActions)[keyof typeof commonStreamActions]>;

type HandledWorkspace = Exclude<Workspaces, 'essential'>;
export const commonStreamActions = {
  streamRequested(
    workspace: HandledWorkspace,
    tabId: string,
    quoteType: QuoteType,
    quoteRequestStartingTimeInMillis: number,
    isReprice: boolean = false,
  ) {
    return {
      type: 'STREAM_REQUESTED' as const,
      tabId,
      workspace,
      quoteType,
      quoteRequestStartingTimeInMillis,
      isReprice,
    };
  },
  streamingQuoteAcked(
    workspace: HandledWorkspace,
    tabId: string,
    quoteId: string,
    quoteType: QuoteType,
    externalQuoteId: string,
    negotiationId: string | undefined,
    estimatedQuotingDurationInMillis: number,
    quoteRequestStartingTimeInMillis: number,
    newVersion: number,
    isExecOnlyAddon: boolean,
    when: Date,
  ) {
    return {
      type: 'STREAMING_QUOTE_ACKED' as const,
      workspace,
      tabId,
      quoteId,
      quoteType,
      externalQuoteId,
      negotiationId,
      estimatedQuotingDurationInMillis,
      quoteRequestStartingTimeInMillis,
      newVersion,
      isExecOnlyAddon,
      isKidExpected: true,
      when,
    };
  },
  streamingCancelled(
    workspace: HandledWorkspace,
    tabId: string,
    quoteType: QuoteType,
    negotiationId?: string,
    quoteId?: string,
    productSubtype?: string,
    productType?: string,
  ) {
    return {
      type: 'STREAMING_CANCELLED' as const,
      workspace,
      quoteType,
      tabId,
      negotiationId,
      quoteId,
      productSubtype,
      productType,
    };
  },
  streamingQuoteFailed(workspace: HandledWorkspace, tabId: string, errors: NextWorkflowError[], when: Date) {
    return {
      type: 'STREAMING_QUOTE_FAILED' as const,
      workspace,
      tabId,
      errors,
      when,
    };
  },
  streamingTradeAuthReceived(workspace: HandledWorkspace, tabId: string, quoteId: string, when: Date) {
    return {
      type: 'STREAMING_TRADE_AUTH_RECEIVED' as const,
      workspace,
      tabId,
      quoteId,
      when,
    };
  },
  streamingTradeRequested(workspace: HandledWorkspace, tabId: string, quoteId: string) {
    return {
      type: 'STREAMING_TRADE_REQUESTED' as const,
      workspace,
      tabId,
      quoteId,
    };
  },
  quoteStreamingTradeDone(
    workspace: HandledWorkspace,
    tabId: string,
    when: Date,
    tradeAck: TradeAck,
    bookingSkipped?: boolean,
  ) {
    return {
      type: 'QUOTE_STREAMING_TRADE_DONE' as const,
      workspace,
      tabId,
      status: 'FULLY_EXECUTED',
      bookingSkipped,
      when,
      ...tradeAck,
    };
  },
};
